import React from "react"
import types from "prop-types"
import {
  editFormSubmissionScheduledReportExportPath,
  formSubmissionReportEditPath,
  newFormSubmissionReportExportPath,
  newFormSubmissionScheduledReportExportPath,
} from "utils/routeHelpers"
import { SUBMISSION_REPORT_TYPE } from "utils/reportHelpers"
import ReportsSection from "./ReportsSection"

const FormLevelReportsSection = ({ className = "" }) => (
  <ReportsSection
    className={className}
    reportType={SUBMISSION_REPORT_TYPE}
    editPath={formSubmissionReportEditPath}
    newReportExportPath={newFormSubmissionReportExportPath}
    newScheduledReportExportPath={newFormSubmissionScheduledReportExportPath}
    editScheduledReportExportPath={editFormSubmissionScheduledReportExportPath}
    title="Form Level Reports"
  />
)

FormLevelReportsSection.propTypes = {
  className: types.string,
}

export default FormLevelReportsSection
